import { useSelector } from 'react-redux'
import { BellSlashIcon } from '@heroicons/react/24/solid'
import { Input, Textarea } from '@/components/ui'
import { formatDate, formatPrice } from '@/utils/formatters'
import Prestataire from '../prestataires/Show'
import { getInterventionStatusLabel, getMaterielStatusLabel, getFacturationStatusLabel } from './interventionsSlice'
import { selectPrestataireById } from '../prestataires/prestatairesSlice'

export default ({ intervention }) => {
  const prestataire = useSelector(state => selectPrestataireById(state, intervention.prestataire_id)) 
  return (
    <div className="bg-base-200 p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">

        <div>
          <Prestataire item={prestataire || intervention?.prestataire } />
          <Input.Display label="Date de l'intervention" value={formatDate(intervention?.date_intervention || '')} />
          <Input.Display label="Montant chantier" value={formatPrice(intervention?.montant || '')} />
          <Input.Display label="Montant matériel" value={formatPrice(intervention?.montant_materiel || '')} />
        </div>
      
        <div>
          <Textarea.Display label="Détail de l'intervention" value={intervention?.details || ''}
            className='flex flex-col items-start'
          />
        </div>

        <div>
          <Input.Display 
            label="Statut de l'intervention" 
            value={intervention?.statut ? 
              getInterventionStatusLabel(intervention.statut) : 
              '' 
            }
          />
          <Input.Display 
            label="Statut du matériel" 
            value={intervention?.statut_materiel ? 
              getMaterielStatusLabel(intervention.statut_materiel) : 
              ''
            } 
            />
          <Input.Display 
            label="Statut de la facturation" 
            value={intervention?.statut_facturation ?
              getFacturationStatusLabel(intervention.statut_facturation) : 
              ''
            } 
          />

          {intervention.do_not_notify && (
            <div className="badge badge-warning gap-2 p-3">
              <BellSlashIcon className="w-4 h-4" />
              Notifications désactivées
            </div>
          )}
        </div> 
      </div>
    </div>
  )
}